import styled, { css } from 'styled-components';

import { IValueProps } from './types';

const Value = styled.div<IValueProps>`
  margin: 3px 8px 3px;
  padding: 4px 8px;
  min-width: 3rem;
  text-align: center;
  font-size: 1rem;
  line-height: 1rem;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ border }) =>
    border &&
    css`
      border: 1px solid ${Styles.color.grey.three};
      border-radius: ${Styles.borderRadius};
      background-color: ${Styles.color.white};
    `}
`;

export default Value;
